@if (contentfulRichBlockContents; as contentfulRichBlockContents) {
  @for (contentfulRichBlockContent of contentfulRichBlockContents; track trackByContentfulRichBlockContent) {
    @if (
      contentfulRichBlockContent.content.length > 0 ||
      contentfulRichBlockContent.textContent ||
      contentfulRichBlockContent.anchorId
    ) {
      <div [id]="contentfulRichBlockContent.anchorId || ''" [ngClass]="contentfulRichBlockContent.classNames">
        @if (contentfulRichBlockContent.textContent) {
          <div [innerHTML]="contentfulRichBlockContent.textContent | sanitizeContent: 'html'"></div>
        } @else {
          <div class="row justify-content-center text-start richText">
            @for (textContent of contentfulRichBlockContent.content; track trackByContentfulRichBlockContent; let i = $index) {
              @if (
                textContent.nodeType === 'embedded-entry-block' &&
                textContent.data.target.sys.contentType.sys.id === 'miniNavigationBlock'
              ) {
                <app-contentful-mininavigation-block [miniNavigation]="textContent.data.target.fields" />
              } @else {
                <div class="col-12 col-lg-10 col-xl-8">
                  <!-- eslint-disable-next-line @angular-eslint/template/no-call-expression -->
                  @if (['heading-2', 'heading-3'].includes(textContent.nodeType)) {
                    @switch (textContent.nodeType) {
                      @case ('heading-2') {
                        <div
                          class="richText__heading-2"
                          [innerHTML]="textContent.processedContent | sanitizeContentfulHTML"
                          [id]="contentfulRichBlockContent.anchorId"
                        ></div>
                      }
                      @case ('heading-3') {
                        <div
                          class="richText__heading-3"
                          [innerHTML]="textContent.processedContent | sanitizeContentfulHTML"
                          [id]="contentfulRichBlockContent.anchorId"
                        ></div>
                      }
                    }
                  }
                  @if (
                    textContent.nodeType === 'paragraph' &&
                    textContent.processedContent !== '' &&
                    textContent.processedContent !== ' '
                  ) {
                    <p [innerHTML]="textContent.processedContent | sanitizeContentfulHTML"></p>
                  }
                  @if (textContent.nodeType === 'unordered-list') {
                    <ul class="unordered-list" [innerHTML]="textContent.processedContent | sanitizeContentfulHTML"></ul>
                  }
                  @if (textContent.nodeType === 'embedded-entry-block') {
                    @if (textContent.content[0]?.value === 'image' && contentfulCloudinaryImage[i]) {
                      <!-- FIXME: Currently using non-null assertion (.asset!) which assumes 'asset' is always present.
                  This can fail if contentful is configured incorrectly, but it is not a problem for now -->
                      <app-contentful-cloudinary-image
                        class="text-center richText__image"
                        [cloudinaryImage]="contentfulCloudinaryImage[i]"
                        [mediaType]="contentfulCloudinaryImage[i].asset!.fields.file?.contentType"
                      />
                    }
                    @if (textContent.content[0]?.value === 'video' && contentfulCloudinaryVideoUrl[i]) {
                      <app-contentful-cloudinary-video
                        class="d-flex justify-content-center w-100"
                        [cloudinaryVideoUrl]="contentfulCloudinaryVideoUrl[i]"
                        [mediaType]="contentfulCloudinaryVideoMediaType[i]"
                      />
                    }
                    @if (textContent.content[0]?.value === 'disclaimer' && contentfulDisclaimerTexts[i]) {
                      <app-contentful-disclaimer
                        [disclaimerText]="contentfulDisclaimerTexts[i]"
                        [mediaType]="contentfulDisclaimerTextsMediaType[i]"
                      />
                    }
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    }
  }
}
